import { ProfilePage, WithContext } from 'schema-dts'
import { Schemas } from '~/api/gen'
import { getMetaTitle } from '~/features/shared/coordinate/lib/getMetaTitle'
import { sexToGender } from '~/lib/gender/converter'
import { getLdImageObject, getLdGender, getLdCentimeter } from '~/lib/jsonLd'

// eslint-disable-next-line complexity
export const getMemberDetailJsonLd = (
  member: Schemas.member_large_detail,
  coordinateCollection: Schemas.get_members_user_name_coordinates_v1_response
): WithContext<ProfilePage> => {
  return {
    '@context': 'https://schema.org',
    '@type': 'ProfilePage',
    mainEntity: {
      '@id': member.user_name,
      '@type': 'Person',
      name: member.nick_name,
      url: `https://wear.jp/${member.user_name}/`,
      sameAs: [
        member.external_url ?? [],
        member.facebook_url ?? [],
        member.twitter_url ?? [],
        member.instagram_url ?? [],
        member.tiktok_url ?? [],
        member.youtube_url ?? [],
      ].flat(),
      description: member.description ?? undefined,
      image: getLdImageObject(member.image.url_640, 640, 768),
      gender: getLdGender(sexToGender(member.sex_id)),
      height: member.model_info.height
        ? getLdCentimeter(member.model_info.height)
        : undefined,
      sponsor: member.sponsored_brands
        ? member.sponsored_brands.map((brand) => ({
            '@type': 'Organization',
            name: brand.sponsor_name,
          }))
        : undefined,
      award: member.awards.map((award) => award.award_cert.name),
      affiliation: member.shop
        ? {
            '@type': 'Organization',
            name: member.shop.name,
            url: `https://wear.jp/shop/${member.shop.id}/`,
            image: member.shop.image.url_640
              ? getLdImageObject(member.shop.image.url_640, 640, 640)
              : undefined,
            address: {
              '@type': 'PostalAddress',
              streetAddress: member.shop.address,
              addressCountry: 'JP',
            },
          }
        : undefined,
    },
    hasPart: coordinateCollection.coordinates.map((coordinate) => {
      return {
        '@type': 'Article',
        headline: getMetaTitle({
          nick_name: coordinate.member.nick_name,
          shop: coordinate.member.shop ?? null,
        }),
        datePublished: coordinate.published_at ?? undefined,
        dateModified: coordinate.updated_at,
        url: `https://wear.jp/${coordinate.member.user_name}/${coordinate.id}/`,
        image: getLdImageObject(coordinate.image.url_1000, 1000, 1200),
      }
    }),
  }
}
